<template>
  <div class="flex flex-col justify-items-center">
    <button
      class="warning-button ml-auto mr-4"
      @click="updateSyncCities()"
      v-if="!loading"
    >
      Sync Cities
    </button>
    <BaseSmallSpinner v-if="loading"></BaseSmallSpinner>
    <template v-else>
      <div id="selection">
        <div
          class="
            flex
            flex-row
            justify-center
            items-center
            bg-white
            border
            border-gray-300
            p-2
            text-center
            m-2
            rounded-md
            hover:bg-gray-300
            hover:text-white
            w-72
          "
          v-if="selectedCity !== ''"
        >
          {{ selectedCity }}
          <button
            @click="selectedCity = ''"
            class="bg-blak rounded-full overflow-hidden text-white w-6 h-6 ml-4 flex justify-center items-center font-bold"
          >
            x
          </button>
        </div>
      </div>
      <div id="cities" class="w-72 p-4" v-if="selectedCity == ''">
        <h1 class="my-2">City Name</h1>
        <input
          class="border border-gray-300 rounded-md w-full p-2 mb-4"
          placeholder="filter state"
          v-model="citySearch"
        />
        <div
          class="
            w-full
            bg-white
            border
            border-gray-300
            p-2
            text-center
            rounded-md
            my-2
            hover:bg-gray-300
            hover:text-white
          "
          v-for="city in filteredCities"
          :key="city.id"
          @click="selectCity(city)"
        >
          <h1>{{ city.cityName }}</h1>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { getCities, getSyncCities } from "@/api/Infoauto.js";
export default {
  name: "Cities",
  data() {
    return {
      cities: [],
      loading: true,
      citySearch: "",
      selectedCity: ""
    };
  },
  props: {
    country: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: true
    }
  },
  async mounted() {
    try {
      this.cities = await getCities(this.country, this.state);
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  },
  computed: {
    filteredCities() {
      return this.cities.filter(city => {
        return city.cityName
          .toLowerCase()
          .includes(this.citySearch.toLowerCase());
      });
    }
  },
  methods: {
    async updateSyncCities() {
      this.loading = true;
      try {
        this.states = await getSyncCities();
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    selectCity(city) {
      this.$emit("selectedCity", city.cityName);
      this.selectedCity = city.cityName;
    },
    deselectCity() {
      this.selectedCity = "";
      this.$emit("deselectedCity");
    }
  }
};
</script>
